module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"template":"Template","from":"from","chooseInterviewer":"Questions will be voiced","cancel":"Cancel","choose":"Choose","templateAiInterview":"Selecting and voicing questions from AI","templateAiInterviewDescription":"The AI will select and voice the questions for your job. You will be able to make changes if necessary."}}')
  delete Component.options._Ctor
}
